import React from "react";

/*creates context of token state which can then
be passed on for authentication purposes*/

const TokenContext = React.createContext();

export default TokenContext;